<template>
  <page-layout
    :show-filter="true"
    :filter-fields="filterFields"
    :filter-show-settings="true"
    :show-action-bar="true"
    :action-bar-show-add="true"
    :action-bar-add-text="'+ 新增入库计划'"
    :action-bar-show-import="true"
    :action-bar-show-export="true"
    :action-bar-show-settings="true"
    @filter-search="handleSearch"
    @filter-reset="handleReset"
    @filter-settings="handleFilterSettings"
    @add="handleAdd"
    @import="handleImport"
    @export="handleExport"
    @action-bar-settings="handleActionBarSettings"
  >
    <template slot="action-left">
      <el-button>次级操作</el-button>
    </template>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="inboundPlanCode" label="入库计划编码" width="180" />
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)" size="small">
            {{ scope.row.status }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="dock" label="月台" width="120" />
      <el-table-column prop="asnTotalCount" label="ASN总单数" width="120" align="right" />
      <el-table-column prop="totalBoxCount" label="总箱数" width="100" align="right" />
      <el-table-column prop="plannedTotalQuantity" label="计划总数量" width="120" align="right" />
      <el-table-column prop="productPackageTotalQuantity" label="商品包装总数量" width="150" align="right" />
      <el-table-column prop="slTotalBoxCount" label="SL总箱数" width="120" align="right" />
      <el-table-column prop="creator" label="创建人" width="120" />
      <el-table-column prop="createTime" label="入库计划创建时间" width="180" />
      <el-table-column prop="estimatedArrivalTime" label="预计到货时间" width="180" />
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-dropdown trigger="click" @command="handleMoreCommand">
            <el-button type="text" size="small">
              更多<i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{action: 'view', row: scope.row}">查看</el-dropdown-item>
              <el-dropdown-item :command="{action: 'delete', row: scope.row}">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[20, 30, 50]"
        :page-size="pageSize"
        :total="total"
        layout="sizes, total, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </page-layout>
</template>

<script>
export default {
  name: 'InboundPlanManagement',
  data() {
    return {
      filterFields: [
        {
          id: 'asnCode',
          label: 'ASN编码',
          component: 'el-select',
          props: {
            placeholder: '请选择',
            clearable: true
          },
          options: [
            { label: '全部', value: 'all' }
          ]
        },
        {
          id: 'upperSystemOrderNo',
          label: '上位系统单号',
          component: 'el-select',
          props: {
            placeholder: '请选择',
            clearable: true
          },
          options: [
            { label: '全部', value: 'all' }
          ]
        },
        {
          id: 'inboundPlanCode',
          label: '入库计划编码',
          component: 'el-input',
          props: {
            placeholder: '请输入入库计划编码'
          }
        },
        {
          id: 'inboundCreateTime',
          label: '入库创建时间',
          component: 'el-date-picker',
          props: {
            type: 'daterange',
            rangeSeparator: '~',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期'
          }
        },
        {
          id: 'estimatedArrivalTime',
          label: '预计到货时间',
          component: 'el-date-picker',
          props: {
            type: 'daterange',
            rangeSeparator: '~',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期'
          }
        }
      ],
      tableData: [
        {
          inboundPlanCode: 'INS202005110008',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        },
        {
          inboundPlanCode: 'INS202005110009',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        },
        {
          inboundPlanCode: 'INS202005110010',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        },
        {
          inboundPlanCode: 'INS202005110011',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        },
        {
          inboundPlanCode: 'INS202005110012',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        },
        {
          inboundPlanCode: 'INS202005110013',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        },
        {
          inboundPlanCode: 'INS202005110014',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        },
        {
          inboundPlanCode: 'INS202005110015',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        },
        {
          inboundPlanCode: 'INS202005110016',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        },
        {
          inboundPlanCode: 'INS202005110017',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        },
        {
          inboundPlanCode: 'INS202005110018',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        },
        {
          inboundPlanCode: 'INS202005110019',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        },
        {
          inboundPlanCode: 'INS202005110020',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        },
        {
          inboundPlanCode: 'INS202005110021',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        },
        {
          inboundPlanCode: 'INS202005110022',
          status: '已提交',
          dock: 'REWORK月台1',
          asnTotalCount: 1,
          totalBoxCount: 1,
          plannedTotalQuantity: 6,
          productPackageTotalQuantity: 6,
          slTotalBoxCount: 6,
          creator: 'moumou.zhang',
          createTime: '2020-11-29 23:00:00',
          estimatedArrivalTime: '2020-11-30 10:00:00'
        }
      ],
      selectedRows: [],
      currentPage: 1,
      pageSize: 20,
      total: 120
    }
  },
  methods: {
    getStatusType(status) {
      const statusMap = {
        '已提交': 'success',
        '待提交': 'warning',
        '已取消': 'info'
      }
      return statusMap[status] || 'info'
    },
    handleSearch() {
      console.log('搜索')
    },
    handleReset() {
      console.log('重置')
    },
    handleFilterSettings() {
      console.log('筛选设置')
    },
    handleAdd() {
      console.log('新增入库计划')
    },
    handleImport() {
      console.log('导入')
    },
    handleExport() {
      console.log('导出')
    },
    handleActionBarSettings() {
      console.log('操作栏设置')
    },
    handleEdit(row) {
      console.log('编辑', row)
    },
    handleMoreCommand(command) {
      console.log('更多操作', command)
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    loadData() {
      console.log('加载数据')
    }
  }
}
</script>

<style scoped>
.pagination-wrapper {
  padding: 16px 0;
  display: flex;
  justify-content: flex-end;
}
</style>



